import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {Table} from "@/components/table/Table.tsx";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {AuditLogChange, AuditLogChangeDetail} from "@/lib/types/auditlogs.ts";

type AuditLogViewModalProps = {
  objectString: string;
  changes: AuditLogChange[];
  showViewModal: boolean;
  setShowViewModal: (show: boolean) => void;
};

const AuditLogChangeDetailTimeClass = "DateTimeField";

export const AuditLogViewModal = ({objectString, changes, showViewModal, setShowViewModal}: AuditLogViewModalProps) => {
  const {user} = useCurrentUserContext();
  const getAuditLogChangeDetail = (changeClass: string, changeDetail: AuditLogChangeDetail) => {
    if (changeClass === AuditLogChangeDetailTimeClass) {
      return changeDetail.value ? shortDateTimeUser(changeDetail.value, user!) : "";
    }
    return changeDetail.verbose;
  };

  return (
    <>
      <ActionDialog
        show={showViewModal}
        title={"Audit Log Detail: " + objectString}
        onCancel={() => setShowViewModal(false)}
        onConfirm={() => {}}
        size="lg"
        hasCancelButton={true}
        hasConfirmButton={false}
        titleClassName={"text-truncate"}
      >
        <Table
          rows={changes}
          specs={[
            {
              meta: {columnClassName: "text-capitalize"},
              fieldName: "attribute",
              accessor: (obj) => obj.verbose_name,
              fieldTitle: "Attribute",
            },
            {
              meta: {columnClassName: "text-break", headerClassName: "text-nowrap"},
              fieldName: "oldValue",
              accessor: (obj) => {
                return <>{!obj.to_many && <div>{getAuditLogChangeDetail(obj.class, obj.old)}</div>}</>;
              },
              fieldTitle: "Old Value",
            },
            {
              meta: {columnClassName: "text-break"},
              fieldName: "newValue",
              accessor: (obj) => {
                return obj.to_many ? (
                  <>
                    {obj.added && obj.added.length > 0 && (
                      <div>
                        <span className="fw-semibold me-1">Added:</span>
                        {obj.added.map(({verbose}) => verbose).join(", ")}
                      </div>
                    )}
                    {obj.removed && obj.removed.length > 0 && (
                      <div>
                        <span className="fw-semibold me-1">Removed:</span>
                        {obj.removed.map(({verbose}) => verbose).join(", ")}
                      </div>
                    )}
                  </>
                ) : (
                  <div>{getAuditLogChangeDetail(obj.class, obj.new)}</div>
                );
              },
              fieldTitle: "New Value",
            },
          ]}
        />
      </ActionDialog>
    </>
  );
};
